import React from 'react';
import PropTypes from 'prop-types';

const MobileAccessIcon = ({ className = null }) => (
  <svg
    fill="#000000"
    className={className}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    width="30px"
    height="30px"
    viewBox="0 0 446.603 446.603"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M99.136,30.305v385.987c0,16.707,13.596,30.311,30.303,30.311h187.723c16.706,0,30.306-13.604,30.306-30.311V30.305
			c0-16.709-13.6-30.305-30.306-30.305h-187.73C112.725,0,99.136,13.596,99.136,30.305z M335.604,30.305v385.987
			c0,10.182-8.267,18.464-18.453,18.464H129.431c-10.166,0-18.453-8.282-18.453-18.464V30.305c0-10.168,8.287-18.456,18.453-18.456
			h187.721C327.338,11.85,335.604,20.137,335.604,30.305z"
      />
      <path
        d="M122.71,52.243v338.863c0,1.635,1.326,2.96,2.961,2.96h195.248c1.635,0,2.966-1.325,2.966-2.96V52.243
			c0-1.636-1.331-2.963-2.966-2.963H125.671C124.036,49.279,122.71,50.607,122.71,52.243z M136.535,55.206h173.521
			c4.362,0,7.901,3.539,7.901,7.898v317.14c0,4.362-3.539,7.901-7.901,7.901H136.535c-4.362,0-7.901-3.539-7.901-7.901V63.104
			C128.634,58.745,132.173,55.206,136.535,55.206z"
      />
      <path
        d="M206.631,31.237h33.33c1.635,0,2.96-1.328,2.96-2.963c0-1.635-1.325-2.963-2.96-2.963h-33.33
			c-1.635,0-2.963,1.328-2.963,2.963C203.668,29.91,204.996,31.237,206.631,31.237z"
      />
      <path
        d="M240.356,400.84h-34.129c-7.008,0-12.71,5.702-12.71,12.7v2.041c0,7.008,5.71,12.71,12.71,12.71h34.129
			c7.008,0,12.71-5.713,12.71-12.71v-2.041C253.077,406.542,247.364,400.84,240.356,400.84z M247.151,415.582
			c0,3.742-3.042,6.784-6.79,6.784h-34.134c-3.737,0-6.787-3.047-6.787-6.784v-2.041c0-3.737,3.06-6.779,6.787-6.779h34.129
			c3.753,0,6.784,3.052,6.784,6.779v2.041H247.151z"
      />
      <path
        d="M251.416,256.743c-4.361,0-7.9-3.539-7.9-7.901v-9.323c0-4.357,2.305-7.896,5.159-7.896h5.159
			c4.666,0,6.424-2.33,7.063-3.722c1.533-3.382-0.157-8.265-4.642-13.406l-13.157-15.082c-3.564-4.093-8.338-6.337-13.416-6.337
			c-5.088,0-9.851,2.252-13.413,6.337l-13.162,15.082c-4.55,5.23-6.297,10.166-4.771,13.533c0.615,1.335,2.298,3.585,6.746,3.585
			c0,0,2.211,0,4.938,0c2.724,0,4.936,3.539,4.936,7.901v25.685c0,11.074,9.024,20.088,20.088,20.088h38.477
			c6.042,0,10.211-1.873,11.74-5.275c1.371-3.058,0.319-6.774-2.951-10.456c-6.23-7.008-12.09-12.812-20.829-12.812H251.416
			L251.416,256.743z M281.255,278.212c-0.741,1.66-3.707,2.687-7.729,2.687h-38.471c-8.65,0-15.699-7.038-15.699-15.696v-35.784
			c0-1.209-0.979-2.199-2.188-2.199H205.09c-0.846,0-2.338-0.132-2.742-1.011c-0.427-0.939-0.135-3.996,4.085-8.823l13.159-15.089
			c2.719-3.12,6.305-4.826,10.101-4.826c3.798,0,7.394,1.714,10.1,4.826l13.162,15.089c4.108,4.709,4.377,7.751,3.94,8.696
			c-0.446,0.995-2.107,1.147-3.057,1.147h-12.518c-1.208,0-2.198,0.985-2.198,2.194v29.523c0,1.208,0.99,2.198,2.198,2.198h20.175
			c6.922,0,11.837,4.91,17.545,11.334C281.066,274.754,281.869,276.846,281.255,278.212z"
      />
      <path
        d="M274.034,158.055h-87.872c-14.135,0-25.629,10.232-25.629,22.8v14.741c0,4.44,3.611,8.059,8.051,8.059h31.402
			c0.632,0,1.224-0.269,1.643-0.733l18.202-20.533c2.331-2.63,5.665-4.141,9.14-4.141c3.047,0,5.982,1.147,8.257,3.224
			l23.603,21.599c0.411,0.371,0.935,0.576,1.488,0.576h29.284c4.438,0,8.059-3.61,8.059-8.059v-14.741
			C299.662,168.287,288.166,158.055,274.034,158.055z M291.608,199.255h-20.54c-4.357,0-10.506-2.387-13.726-5.332l-17.153-15.699
			c-3.088-2.82-7.079-4.377-11.218-4.377c-4.748,0-9.267,2.046-12.426,5.608l-12.301,13.881c-2.892,3.263-8.777,5.911-13.137,5.911
			h-22.516c-2.024,0-3.667-1.646-3.667-3.659v-14.741c0-10.144,9.529-18.408,21.236-18.408h87.872
			c11.71,0,21.235,8.257,21.235,18.408v14.741C295.275,197.61,293.635,199.255,291.608,199.255z"
      />
    </g>
  </svg>
);

MobileAccessIcon.propTypes = {
  className: PropTypes.string,
};


export default MobileAccessIcon;
